export const POST_MENTION_PAGE_SIZE = 10;
export const COMMENT_MENTION_PAGE_SIZE = 8;
export const CHAT_MENTION_PAGE_SIZE = 5;
